/**
 * Route for `aws-s3-data-export-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AwsS3DataExportIntegrationPage } from "../features/aws-s3-data-export-integration/AwsS3DataExportIntegrationPage";

export const awsS3DataExportIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/aws-s3-data-export-integration",
	component: AwsS3DataExportIntegrationPage,
});

export default awsS3DataExportIntegrationRoute;
